module.exports = __webpack_public_path__ + "img/bg1.42b403fb.png";